import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Container } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import M2MTest from './M2MTest';

// Standalone, PRE-AUTH M2M token test. Reuses the <M2MTest /> component (identical UI to the authed
// /m2m page) but WITHOUT AppLayout/session — the M2M flow is client_credentials (login-independent),
// so the /api/m2m/* endpoints are reachable anonymously. Linked from the login page. Testing product
// only — this deliberately exposes the full, usable M2M token to any visitor.
const M2MPublicTest = () => (
  <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
    <Box sx={{ height: 6, background: 'linear-gradient(90deg, #6B46C1 0%, #9F7AEA 100%)' }} />
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 3,
        py: 2
      }}
    >
      <Box component="img" src="/logo.png" alt="Milient" sx={{ height: 36 }} />
      <Button
        component={RouterLink}
        to="/login"
        startIcon={<ArrowBackIcon />}
        sx={{ textTransform: 'none' }}
      >
        Back to login
      </Button>
    </Box>
    <Container maxWidth="md" sx={{ py: 3 }}>
      <M2MTest />
    </Container>
  </Box>
);

export default M2MPublicTest;
